import classNames from 'classnames';
import { forwardRef } from 'react';
import { TabContainer } from '../styles';
import { useEventTimelineSteps } from './use_event_timeline_steps';
const timelineContainerCss = "t1uk5hpw";
const TimelineContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timelineContainerCss, props.className)} />;
});
export const TimelineTab = ({
  selectedEvent
}) => {
  const {
    steps
  } = useEventTimelineSteps(selectedEvent);
  return <TabContainer>
      <TimelineContainer>
        {steps.map(({
        step
      }) => step)}
      </TimelineContainer>
    </TabContainer>;
};

require("./timeline_tab.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./timeline_tab.js");